import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';

import ScheduleGradeMainChangeGroupTab from './ScheduleGradeMainChangeGroupTab';
import ScheduleGradeMainEditGroupTab from './ScheduleGradeMainEditGroupTab';

class ScheduleMainTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      warning_alert: false,
      warning_alert_add: false,
      loaded: 0,
      staffs: [],
      groups: [],
      open_schedule_grade_groups: [],
      open_schedule_grade_group_periods: [],
      regimes_select: [],
      groups_select: [],
      periods: [],
      schedule: {},
      schedule_grade_groups: {},
      schedule_grade_staffs: {},
      schedule_grade_group_staff: {},
      schedule_grade_group_staff_periods: {},
      modal_staff: {},
      aircraft_models: {},
      aircraft_model_subtypes: {},
      schedule_grade_group_staff_id: null,
      staff_id: null,
      schedule_grade_group_id: null,
      role_id: null,
      period: null,
      schedule_period_id: null,
      group_id: null,
      modal_schedule_period_id: null,
      modal_transfered: null,
      modal_schedule_grade: null,
      modal_schedule_grade_group: null,
      modal_schedule_grade_group_period: null,
      modal_schedule_grade_group_remaining: 0,
      modal_group: null,
    };

    this.openAddModal = this.openAddModal.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deletePeriodLine = this.deletePeriodLine.bind(this);
    this.addPeriodLine = this.addPeriodLine.bind(this);
    this.editPeriod = this.editPeriod.bind(this);
    this.editTransfered = this.editTransfered.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.editGroup = this.editGroup.bind(this);
    this.editModalPeriods = this.editModalPeriods.bind(this);
    this.confirmEditModalPeriods = this.confirmEditModalPeriods.bind(this);
    this.loadStaffInfo = this.loadStaffInfo.bind(this);
    this.loadGroupInfo = this.loadGroupInfo.bind(this);
    this.transferGrade = this.transferGrade.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.exportCsv = this.exportCsv.bind(this);
    this.changeScheduleEditGroup = this.changeScheduleEditGroup.bind(this);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleSelectChangeGroup(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      change['open_schedule_grade_group_periods'] = null;
    } else {
      change[name] = event.value;
      this.loadGroupInfo(event.value);
    }
    this.setState(change);
  }

  handleSelectChangeStaff(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    this.loadStaffInfo(event.value);
  }

  handleSelectChangeModal(name, index, event) {
    var change = this.state.schedule_grade_group_staff_periods;
    if(event == null) {
      change[index][name] = null;
    } else {
      change[index][name] = event.value;
    }
    this.setState({schedule_grade_group_staff_periods: change});
  }

  handleChangeModal (name, index, event) {
    var change = this.state.schedule_grade_group_staff_periods;
    change[index][name] = event.target.value;
    this.setState({schedule_grade_group_staff_periods: change});
  }


  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.staffs) && Array.isArray(newProps.schedule_grade_groups) && Array.isArray(newProps.aircraft_models) && Array.isArray(newProps.aircraft_model_subtypes) && Array.isArray(newProps.groups) && Array.isArray(newProps.regimes_select) && Array.isArray(newProps.roles) && Array.isArray(newProps.periods) && Array.isArray(newProps.open_schedule_grade_groups) && typeof newProps.schedule.id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        staffs: newProps.staffs,
        groups: newProps.groups,
        roles: newProps.roles,
        periods: newProps.periods,
        regimes_select: newProps.regimes_select,
        schedule_grade_staffs: newProps.schedule_grade_staffs,
        schedule_grade_groups: newProps.schedule_grade_groups,
        open_schedule_grade_groups: newProps.open_schedule_grade_groups,
        aircraft_models: newProps.aircraft_models,
        aircraft_model_subtypes: newProps.aircraft_model_subtypes,
        groups_select: newProps.groups_select,
        schedule: newProps.schedule,
        loaded: 1,
      });
    }
  }

  // Adiciono um colaborador na escala
  add(event) {
    this.props.handleAlert('', '', 'open');
    this.setState({
      modal_add: false,
    });
    var datasave = {
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      staff_id: this.state.staff_id,
      schedule_grade_group_id: this.state.schedule_grade_group_id,
      role_id: this.state.role_id,
      regime_id: this.state.regime_id,
      schedule_period_id: this.state.schedule_period_id,
      change_schedule: event,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/adicionar/colaborador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
        }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Adiciono um colaborador na escala
  openAddModal(event) {
    event.preventDefault();
    this.setState({
      modal_add: true,
    });
  }

  // Edita o id do período de um colaborador
  editPeriod(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_period_id: this.state.modal_schedule_period_id,
      schedule_grade_group_staff_id: this.state.schedule_grade_group_staff_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/trocar/periodo/colaborador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Edita o transfered de um colaborador
  editTransfered(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      transfered: this.state.modal_transfered,
      schedule_grade_group_staff_id: this.state.schedule_grade_group_staff_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/trocar/destaque/colaborador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  transferGrade(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_period_id: this.state.modal_schedule_grade_group_period,
      remaining: this.state.modal_schedule_grade_group_remaining,
      remaining_next_month: this.state.modal_schedule_grade_group_remaining_next_month,
      next_month: this.state.modal_schedule_grade_group_next_month,
      schedule_grade_group_change_id: this.state.modal_schedule_grade_group,
      schedule_grade_group_staff_id: this.state.schedule_grade_group_staff_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/trocar/grade/colaborador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Edita o grupo de um colaborador
  editGroup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_group_id: this.state.modal_group,
      schedule_grade_group_staff_id: this.state.schedule_grade_group_staff_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/trocar/grupo/colaborador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status !== 'warning') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        } else {
          self.setState({ warning_edit_group: true });
          self.props.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  changeScheduleEditGroup(event) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_group_id: this.state.modal_group,
      schedule_grade_group_staff_id: this.state.schedule_grade_group_staff_id,
      period_decision: this.state.period_decision,
      staff_decision: this.state.staff_decision,
      edit_group_next_month: this.state.edit_group_next_month,
      change_schedule_group: event,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/trocar/grupo/colaborador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status !== 'warning') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Edita o grupo de um colaborador
  addGroup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      group_id: this.state.group_id,
      schedule_grade_id: this.props.schedule_grade_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/adicionar/grupo/escala', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Busca infos de select do colaborador selecionado
  loadStaffInfo(staff_id) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador/info/escala/' + staff_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({
          regime_id: responseJson.data.regime_id,
          role_id: responseJson.data.role_id
        });
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Busca infos de select do grupo selecionado
  loadGroupInfo(group_id) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/grupo/select/escala/' + group_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ open_schedule_grade_group_periods: responseJson.data });
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Deleta um colaborador na escala
  delete(schedule_grade_group_staff_id) {
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse colaborador?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/grupo/colaborador/' + schedule_grade_group_staff_id, { method: 'DELETE', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Adiciono uma aeronave na escala
  openModal(schedule_grade_group_staff_id) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/colaborador/' + schedule_grade_group_staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert('', '', 'closed');
        if (responseJson.status === 'success') {
          self.setState({
            modal: true,
            schedule_grade_group_staff: responseJson.data.schedule_grade_group_staff,
            schedule_grade_group_staff_periods: responseJson.data.schedule_grade_group_staff.schedule_grade_group_staff_periods,
            modal_staff: responseJson.data.schedule_grade_group_staff.staff,
            modal_group: responseJson.data.schedule_grade_group_staff.schedule_grade_group_id,
            modal_transfered: responseJson.data.schedule_grade_group_staff.transfered,
            modal_schedule_period_id: responseJson.data.schedule_grade_group_staff.schedule_period_id,
            schedule_grade_group_staff_id: responseJson.data.schedule_grade_group_staff.id,
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Deleta uma linha de período do modal
  deletePeriodLine(deleted_index) {
    var self = this;
    var new_periods = {};
    var x = 0;
    Object.keys(self.state.schedule_grade_group_staff_periods).map(function(k) {
      if(deleted_index !== k) {
        new_periods[x] = self.state.schedule_grade_group_staff_periods[k];
        x++;
      }
    })
    this.setState({schedule_grade_group_staff_periods: new_periods})
  }

  // Adiciona uma linha de período do modal
  addPeriodLine() {
    var self = this;
    var x = 0;
    var new_periods = self.state.schedule_grade_group_staff_periods
    Object.keys(self.state.schedule_grade_group_staff_periods).map(function(k) {
      x++;
    });
    new_periods[x] = {
      date_finish_str: null,
      date_start_str: null,
      type: "MIS",
    };
    this.setState({schedule_grade_group_staff_periods: new_periods})
  }

  closeModal() {
    this.setState({
      modal: false,
      modal_staff: {},
      schedule_grade_group_staff_id: null,
      schedule_grade_group_staff: {},
      open_schedule_grade_group_periods: [],
      modal_schedule_grade_group_remaining: 0,
      modal_schedule_grade_group: null,
      schedule_grade_group_staff_periods: {}
    });
    this.props.handleAlert('', '', 'open');
    this.props.updateData();
  }
  
  exportCsv(event) {
    var self = this;
    var url = "/exportar/escala/grade/vencimentos/csv/"+self.props.schedule_grade_id;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  // Edita os períodos de um colaborador
  confirmEditModalPeriods(event) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_group_staff_periods: this.state.schedule_grade_group_staff_periods,
      schedule_grade_group_staff_id: this.state.schedule_grade_group_staff_id,
      change_schedule: event,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/trocar/periodos/colaborador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status !== 'warning') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ schedule_grade_group_staff_id: responseJson.data, warning_alert: false });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  editModalPeriods() {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_group_staff_periods: this.state.schedule_grade_group_staff_periods,
      schedule_grade_group_staff_id: this.state.schedule_grade_group_staff_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/trocar/periodos/colaborador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status !== 'warning') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        } else {
          self.setState({ warning_alert: true });
          self.props.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }



  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Grupos</h3>
  <hr/>
  <form onSubmit={this.addGroup}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Grupo:</label>
        <Select
          className="form-field-name"
          name="group_id"
          value={this.state.group_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'group_id')}
          options={this.state.groups_select}
          required
        />
      </div>
      <div className="col-md-6 form-group">
        <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Adicionar grupo</button>
      </div>
    </div>
  </form>
  <hr/>
  <table className="table table-hover table-stripped table-bordered">
    <thead>
      <tr>
        <th style={{width: '55px'}} className="text-center">Grupo</th>
        <th style={{width: '55px'}} className="text-center">Início</th>
        <th style={{width: '55px'}} className="text-center">Fim</th>
        <th style={{width: '55px'}} className="text-center">Turno</th>
        <th style={{width: '55px'}} className="text-center col-md-1">Edição</th>
        <th style={{width: '200px'}} className="text-center">Associar grupo</th>
        <th style={{width: '55px'}} className="text-center col-md-1"></th>
      </tr>
    </thead>
    <tbody>
      {Object.keys(self.state.schedule_grade_groups).map(function(k) {
        return(
          <ScheduleGradeMainEditGroupTab schedule_grade_group_id={self.state.schedule_grade_groups[k].id} schedule_grade_group_name={self.state.schedule_grade_groups[k].name} schedule_grade_group_hour_start={self.state.schedule_grade_groups[k].hour_start} schedule_grade_group_hour_finish={self.state.schedule_grade_groups[k].hour_finish} schedule_grade_group_turn={self.state.schedule_grade_groups[k].turn} groups_select={self.state.groups_select} base_setting_group_id={self.state.schedule_grade_groups[k].base_setting_group_id} updateData={self.props.updateData} updated={self.state.updated} handleAlert={self.props.handleAlert} />
        );
      })}
    </tbody>
  </table>
  <hr/>
  <h3>Adicionar colaborador a escala</h3>
  <hr/>
  <form onSubmit={this.openAddModal}>
    <div className="row">
      <div className="col-md-3 form-group">
        <label>Colaborador:</label>
        <Select
          className="form-field-name"
          name="staff_id"
          value={this.state.staff_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChangeStaff.bind(this, 'staff_id')}
          options={this.state.staffs}
          required
        />
      </div>
      <div className="col-md-2 form-group">
        <label>Grupo:</label>
        <Select
          className="form-field-name"
          name="schedule_grade_group_id"
          value={this.state.schedule_grade_group_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'schedule_grade_group_id')}
          options={this.state.groups}
          required
        />
      </div>
      <div className="col-md-2 form-group">
        <label>Regime de trabalho:</label>
        <Select
          className="form-field-name"
          name="regime_id"
          value={this.state.regime_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'regime_id')}
          options={this.state.regimes_select}
          required
        />
      </div>
      <div className="col-md-2 form-group">
        <label>Função:</label>
        <Select
          className="form-field-name"
          name="role_id"
          value={this.state.role_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'role_id')}
          options={this.state.roles}
          required
        />
      </div>
      <div className="col-md-3 form-group">
        <label>Período personalizado:</label>
        <Select
          className="form-field-name"
          name="schedule_period_id"
          value={this.state.schedule_period_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'schedule_period_id')}
          options={this.state.periods}
          required
        />
      </div>
    </div>
    <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Adicionar colaborador</button>
  </form>
  <Modal show={self.state.modal_add} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4>Será feita a alteração na escala do mês seguinte, caso o colaborador esteja escalado?</h4>
      <p>Obs.: Essa ação abrirá uma nova revisão caso a grade ja esteja aprovada. Igualando o primeiro dia do mês seguinte, com o último dia do período do colaborador nesta escala.</p>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_add: false}); self.props.handleAlert('', '', 'open'); }}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
          <div className="col-md-6">
            <button onClick={() => {self.add(true);}} className="btn btn-block btn-success"><i className="fa fa-fw fa-save"></i> SIM</button>
          </div>
          <div className="col-md-6">
            <button onClick={() => {self.add(false);}} className="btn btn-block btn-danger"><i className="fa fa-fw fa-save"></i> NÂO</button>
          </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_add: false}); self.props.handleAlert('', '', 'open'); }}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <hr/>
  <button className="btn btn-success btn-xs button-inline" value={this.state.data} onClick={this.exportCsv}>
    <i className="fa fa-fw fa-table"></i> Exportar em CSV
  </button>
  {Object.keys(self.state.schedule_grade_staffs).map(function(group) {
    var sgs = self.state.schedule_grade_staffs[group];
    return(
      <div>
        <h3 className="subtitulo-schedule">{group}</h3>
        {Object.keys(sgs).map(function(period) {
          return(
            <div className="table-responsive">
              <table className="table table-hover table-stripped table-bordered tabela-view-schedule">
                <thead>
                  <tr>
                    <th className="text-center" style={{width: '65px'}}>Ações</th>
                    <th className="text-center" style={{width: '105px'}}>Função</th>
                    <th className="text-center" style={{width: '45px'}}>Mat.</th>
                    <th className="text-center" style={{width: '165px'}}>Nome</th>
                    <th className="text-center" style={{width: '165px'}}>Residência</th>
                    <th className="text-center" style={{width: '55px'}}>AVI</th>
                    <th className="text-center" style={{width: '55px'}}>CEL</th>
                    <th className="text-center" style={{width: '55px'}}>GMP</th>
                    <th className="text-center" style={{width: '165px'}}>{period}</th>
                    {Object.keys(self.state.aircraft_models).map(function(k) {
                      return(
                        <th  className="text-center" style={{width: '95px'}}>{self.state.aircraft_models[k]}</th>
                      );
                    })}
                    {Object.keys(self.state.aircraft_model_subtypes).map(function(k) {
                      return(
                        <th  className="text-center" style={{width: '95px'}}>{self.state.aircraft_model_subtypes[k]}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                {Object.keys(sgs[period]).map(function(k) {
                  var line = sgs[period][k];
                  return(
                    <tr>
                      <td className="text-center">
                        <button className="btn btn-xs btn-primary" onClick={() => {self.openModal(line.sggs_id)}}><i className="fa fa-fw fa-pencil"></i></button>
                        <button className="btn btn-xs btn-danger" onClick={() => {self.delete(line.sggs_id)}}><i className="fa fa-fw fa-trash"></i></button>
                      </td>
                      <td className="text-center">{line.role}</td>
                      <td className="text-center">{line.inscription}</td>
                      <td className="text-center">{line.name}</td>
                      <td className="text-center">{line.city}</td>
                      <td className="text-center">{line.AVI}</td>
                      <td className="text-center">{line.CEL}</td>
                      <td className="text-center">{line.GMP}</td>
                      <td className="text-center">{line.period}</td>
                      {Object.keys(self.state.aircraft_models).map(function(k) {
                        if (typeof line[self.state.aircraft_models[k]] !== 'undefined') {
                          return(
                            <td  className={line[self.state.aircraft_models[k]].verify == 1 ? 'schedule-td-success' : 'schedule-td-error'}>{line[self.state.aircraft_models[k]].expiration}</td>
                          );
                        } else {
                          return(
                            <td  className={'schedule-td-error'}></td>
                          );
                        }
                      })}
                      {Object.keys(self.state.aircraft_model_subtypes).map(function(k) {
                        if (typeof line[self.state.aircraft_model_subtypes[k]] !== 'undefined') {
                          return(
                            <td  className={line[self.state.aircraft_model_subtypes[k]].verify == 1 ? 'schedule-td-success' : 'schedule-td-error'}>{line[self.state.aircraft_model_subtypes[k]].expiration}</td>
                          );
                        } else {
                          return(
                            <td  className={'schedule-td-error'}></td>
                          );
                        }
                      })}
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    );
  })}
  <Modal show={self.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Edição - {self.state.modal_staff.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.closeModal()}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <h4>Editar períodos</h4>
      <hr/>
      {Object.keys(self.state.schedule_grade_group_staff_periods).map(function(k) {
        return(
          <div className="row">
            <div className="col-md-4 form-group">
              <label>Data inicial:</label>
              <InputMask value={self.state.schedule_grade_group_staff_periods[k].date_start_str}  maskChar={null} name="date_start_str" mask="99/99/9999" className="form-control" onChange={self.handleChangeModal.bind(self, 'date_start_str', k)} required placeholder="" />
            </div>
            <div className="col-md-4 form-group">
              <label>Data final:</label>
              <InputMask value={self.state.schedule_grade_group_staff_periods[k].date_finish_str}  maskChar={null} name="date_finish_str" mask="99/99/9999" className="form-control" onChange={self.handleChangeModal.bind(self, 'date_finish_str', k)} required placeholder="" />
            </div>
            <div className="col-md-3 form-group">
              <label>Tipo:</label>
              <Select
                className="form-field-name"
                name="type"
                value={self.state.schedule_grade_group_staff_periods[k].type}
                searchable={true}
                placeholder={''}
                onChange={self.handleSelectChangeModal.bind(self, 'type', k)}
                options={[
                  {value: 'MIS', label: 'MIS'},
                  {value: 'FE', label: 'FE'},
                  {value: 'FR', label: 'FR'},
                  {value: 'MIS-A', label: 'MIS-A'},
                  {value: "TROCA", label: "TROCA"},
                ]}
                required
              />
            </div>
            <div className="col-md-1 form-group">
              <button onClick={() => {self.deletePeriodLine(k);}} className="btn btn-danger btn-inline"><i className="fa fa-fw fa-close"></i></button>
            </div>
          </div>
        );
      })}
      <div className="row">
        <div className="col-md-6">
          <button onClick={() => {self.editModalPeriods();}} className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Salvar períodos</button>
        </div>
        <div className="col-md-6">
          <button onClick={() => {self.addPeriodLine();}} className="btn btn-block btn-success"><i className="fa fa-fw fa-plus"></i> Adicionar período</button>
        </div>
      </div>
      {(this.state.warning_alert == true ? 
        <div>
          <hr/>
          <div className="row">
              <div className="col-md-12">
                <h4>O colaborador possui a sigla do primeiro dia na escala do mês seguinte diferente da sigla atual, deseja atualizar a escala do mês seguinte?</h4>
              </div>
              <div className="col-md-6">
                <button onClick={() => {self.confirmEditModalPeriods(true);}} className="btn btn-block btn-success"><i className="fa fa-fw fa-check"></i> SIM</button>
              </div>
              <div className="col-md-6">
                <button onClick={() => {self.confirmEditModalPeriods(false);}} className="btn btn-block btn-danger"><i className="fa fa-fw fa-close"></i> NÂO</button>
              </div>
          </div>

        </div>
      : ''
      )}
      <hr/>
      <h4>
        Modificar período personalizado<br/>
        <small>Esta ação não troca os dias do funcionário, apenas indica qual período ele deve estar relacionado para duplicação de escala</small>
      </h4>
      <hr/>
      <form onSubmit={this.editPeriod}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Período personalizado:</label>
            <Select
              className="form-field-name"
              name="modal_schedule_period_id"
              value={this.state.modal_schedule_period_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'modal_schedule_period_id')}
              options={this.state.periods}
              required
            />
          </div>
          <div className="col-md-6">
            <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Editar período</button>
          </div>
        </div>
      </form>
      <hr/>
      <div className="row">
        <div className="col-md-6">
          <h4>Transferir para outro grupo</h4>
          <hr/>
          <form onSubmit={this.editGroup}>
            <div className="form-group">
              <label>Grupo:</label>
              <Select
                className="form-field-name"
                name="modal_group"
                value={this.state.modal_group}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'modal_group')}
                options={this.state.groups}
                required
              />
            </div>
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Confirmar modificação</button>
            </div>
          </form>
        </div>
        <div className="col-md-6">
          <h4>Marcar/desmarcar destaque em azul</h4>
          <hr/>
          <form onSubmit={this.editTransfered}>
            <div className="form-group">
              <label>Transferido?</label>
              <Select
                className="form-field-name"
                name="modal_transfered"
                value={this.state.modal_transfered}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'modal_transfered')}
                options={[
                  {value: 0, label: 'Não'},
                  {value: 1, label: 'Sim'},
                ]}
                required
              />
            </div>
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Confirmar modificação</button>
            </div>
          </form>
        </div>
      </div>
      <hr/>
      <h4>Transferir para outra escala</h4>
      <hr/>
      <form onSubmit={this.transferGrade}>
        <div className="row">
          <div className="form-group col-md-4">
            <label>Escala:</label>
            <Select
              className="form-field-name"
              name="modal_schedule_grade_group"
              value={this.state.modal_schedule_grade_group}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChangeGroup.bind(this, 'modal_schedule_grade_group')}
              options={this.state.open_schedule_grade_groups}
              required
            />
          </div>
          <div className="form-group col-md-4">
            <label>Período:</label>
            <Select
              className="form-field-name"
              name="modal_schedule_grade_group_period"
              value={this.state.modal_schedule_grade_group_period}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'modal_schedule_grade_group_period')}
              options={this.state.open_schedule_grade_group_periods}
              required

            />
          </div>
          <div className="form-group col-md-4">
            <label>Deseja manter na escala atual?</label>
            <Select
              className="form-field-name"
              name="modal_schedule_grade_group_remaining"
              value={this.state.modal_schedule_grade_group_remaining}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'modal_schedule_grade_group_remaining')}
              options={[
                {value: 0, label: 'Não'},
                {value: 1, label: 'Sim'},
              ]}
              required

            />
          </div>
          <div className="form-group col-md-4">
              <label>Deseja incluir na nova base do mês seguinte?</label>
              <Select
              className="form-field-name"
              name="modal_schedule_grade_group_next_month"
              value={this.state.modal_schedule_grade_group_next_month}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'modal_schedule_grade_group_next_month')}
              options={[
                  {value: 0, label: 'Não'},
                  {value: 1, label: 'Sim'},
              ]}
              required
              />
          </div>
          {(this.state.modal_schedule_grade_group_next_month == 1 ? 
            <div className="form-group col-md-4">
                <label>Deseja manter na base atual do mês seguinte?</label>
                <Select
                className="form-field-name"
                name="modal_schedule_grade_group_remaining"
                value={this.state.modal_schedule_grade_group_remaining_next_month}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'modal_schedule_grade_group_remaining_next_month')}
                options={[
                    {value: 0, label: 'Não'},
                    {value: 1, label: 'Sim'},
                ]}
                required
                />
            </div>
          : ''
          )}
        </div>
        <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Confirmar mudança</button>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.closeModal()}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ScheduleMainTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleMainTab.js